// extracted by mini-css-extract-plugin
module.exports = {"anchorMenu":"style_anchorMenu__ZWM2m","anchor":"style_anchor__1xnKL","bubble":"style_bubble__14XRY","anchorSelected":"style_anchorSelected__2w_QX","label":"style_label__l9MrX"};